// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__22Foq","additionalInfo":"AgreementModal_additionalInfo__1Lqey"};